export default "__VITE_ASSET__8312df17__"